import { Trans } from '@lingui/react'
import { clsx } from 'clsx'
import { type FunctionComponent } from 'react'

import MountPoints from 'shared/utils/mountPoints'
import SearchSuggestionName from 'views/components/organisms/SearchBox/SearchBoxListItem/SearchSuggestionName'
import withMountPoints from 'views/enhancers/withMountPoints'

import { type SearchHistorySuggestion } from './types'

type ComponentProps = {
  hits: SearchHistorySuggestion[]
  mountPoints: MountPoints
  hasSearchHistory: boolean
}
const TopSearches: FunctionComponent<ComponentProps> = ({
  hits,
  mountPoints,
  hasSearchHistory,
}) => {
  return (
    <div
      className={clsx(
        'u-padding--right@medium o-SearchBox__top-searches-product__wrapper',
        {
          'u-padding--right@medium u-padding-small--right': hasSearchHistory,
        }
      )}
    >
      <div className="o-SearchBox__top-searches-product__title u-font-weight--bold">
        <Trans id="searchBox.label.popularSearches" />
      </div>
      <ul className="a-list-reset u-padding--top o-SearchBox__top-searches__list-item__list">
        {hits.map(({ query, queryID, objectID }, index) => (
          <li
            className="u-padding-xx-small--ends o-SearchBox__top-searches__list-item__wrapper"
            key={query}
          >
            <a
              className="a-link"
              href={
                mountPoints.getSearch({
                  query: query ?? '',
                  // @ts-ignore
                  trackingData: {
                    eventName: 'click on query in pre-suggest',
                    eventType: 'click',
                    objectIDs: `[${objectID}]`,
                    queryID: queryID!,
                    position: index + 1,
                  },
                })!
              }
              data-clientside-hook="SearchBoxListSuggestLink"
            >
              <span className="o-SearchBox__label">
                <SearchSuggestionName name={query} />
              </span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default withMountPoints(TopSearches)
